import axios from 'axios';
import { getOmniLogger } from 'omni-package-react-logging';

export default function downloadAndOpenFile(
  url: string,
  fileName = 'Attachment.pdf',
  mime: 'application/pdf' | 'application/octet-stream' = 'application/pdf',
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  callback: (success: boolean) => void = () => { },
) {
  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  axios.get(url, {
    responseType: 'blob',
  }).then((res) => {
    try {
      const { data } = res;
      const newMime = res.headers['content-type'];
      if (!(data instanceof Blob)) {
        callback(false);
        return;
      }
      const exportUrl = URL.createObjectURL(new File([data], fileName, { type: newMime ?? mime }));
      const result = window.open(exportUrl);
      if (result === null) {
        getOmniLogger('download').error(new Error('Cannot open file'));
        callback(false);
        return;
      }
      callback(true);
      return;
    } catch (e) {
      getOmniLogger('download').error(e);
      callback(false);
    }
  }).catch((e) => {
    getOmniLogger('download').error(e);
    callback(false);
  });
}
